import { Fox } from "../components/Fox.js";
import { ButtonLink, Card } from "../components/ui.js";
import { auth } from "../copy/auth.js";
import { common } from "../copy/common.js";

/**
 * The signed-out start. «Ich habe schon ein Konto» is the primary action:
 * whoever gets a class code arrives through the join flow anyway, so the code
 * does not have to be the default for everybody (issue #22). The class code
 * and practising alone stay visible, one step down.
 *
 * No privacy slogan here. «Kein echter Name» only makes sense next to a name,
 * and the first name a child sees is the rolled one on the register screen
 * (docs/PROFILE.md, docs/UX.md §7).
 */
export function WelcomeScreen() {
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-md flex-col justify-between gap-10 px-5 py-10 sm:max-w-lg sm:px-8 lg:max-w-5xl lg:justify-center lg:py-16">
      <div className="lg:grid lg:grid-cols-2 lg:items-center lg:gap-14 xl:gap-20">
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
          <Fox mood="happy" className="h-32 w-32 sm:h-40 sm:w-40 lg:h-56 lg:w-56" />
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl">
            Voci<span className="text-fox">Fuchs</span>
          </h1>
          <p className="mt-3 max-w-sm text-lg text-ink-soft sm:text-xl lg:text-2xl">
            {common.tagline}
          </p>
          <p className="mt-5 max-w-sm text-ink-soft">{auth.welcome.what}</p>
          <p className="mt-2 max-w-sm text-ink-soft">{auth.welcome.how}</p>
        </div>

        <Card className="mt-10 space-y-3 p-5 sm:p-7 lg:mt-0">
          <ButtonLink to="/login" className="text-lg">
            {auth.welcome.alreadyHaveAccount}
          </ButtonLink>

          <p className="pt-2 text-sm font-semibold text-ink-soft">{auth.welcome.newHere}</p>
          <ButtonLink to="/register?join=1" variant="ghost">
            {auth.welcome.hasClassCode}
          </ButtonLink>
          <ButtonLink to="/register" variant="ghost">
            {auth.welcome.practiceAlone}
          </ButtonLink>
        </Card>
      </div>

      <p className="text-center text-sm text-ink-soft">{auth.welcome.footer}</p>
    </div>
  );
}
